import { getBarStyles } from './utils';

const maxBarWidth = 232;

type HorizontalBarProps = {
  color: string;
  baseline: number;
  value: number;
  max: number;
};

export const HorizontalBar = ({ max, value, baseline = 0, color }: HorizontalBarProps) => {
  const maxValueStyles = value === max ? `rounded-e-none` : '';
  const { diffBarStyles, barStyles, barSize, diffBarSize } = getBarStyles({
    max,
    baseline,
    color,
    isVertical: false,
    maxBarSize: maxBarWidth,
    value,
  });

  return (
    <div className="flex items-center gap-0.5">
      <div className={`${barStyles} ${maxValueStyles} h-[10px]`} style={{ width: barSize }} />
      {!!baseline && <div className={`${diffBarStyles} rounded-e h-[10px]`} style={{ width: diffBarSize }} />}
      <div className="text-s-m text-base-20">{value || ''}</div>
    </div>
  );
};
